<template>
  <div
    :class="$style.wrapper"
    ref="wrapper"
    :style="detectorHeightVariableStyle"
  >
    <div
      :class="[$style.wrapper__detector, $style['wrapper__detector--top']]"
      ref="onTopDetector"
    />
    <slot />
    <div
      :class="[$style.wrapper__detector, $style['wrapper__detector--bottom']]"
      ref="onBottomDetector"
    />
  </div>
</template>

<script lang="ts" setup>
import { computed, onUnmounted, ref } from 'vue'
import { useIntersectionObserver } from '@vueuse/core'
const props = withDefaults(
  defineProps<{
    detectorHeight?: number
  }>(),
  {
    detectorHeight: 5,
  }
)

const emit = defineEmits<{
  (event: 'topStateChange', payload: { onTop: boolean }): void
  (event: 'bottomStateChange', payload: { onBottom: boolean }): void
}>()

const wrapper = ref<HTMLElement | null>(null)
const onTopDetector = ref<HTMLElement | null>(null)
const onBottomDetector = ref<HTMLElement | null>(null)

const detectorHeightVariableStyle = computed(() => ({
  '--detector-height': `${props.detectorHeight}px`,
}))

const { stop: stopTopDetector } = useIntersectionObserver(
  onTopDetector,
  ([{ isIntersecting }]) => {
    emit('topStateChange', { onTop: isIntersecting })
  }
)
const { stop: stopBottomDetector } = useIntersectionObserver(
  onBottomDetector,
  ([{ isIntersecting }]) => {
    emit('bottomStateChange', { onBottom: isIntersecting })
  }
)
onUnmounted(() => {
  stopTopDetector()
  stopBottomDetector()
})

defineExpose({
  wrapperRef: wrapper,
})
</script>

<style lang="scss" module>
.wrapper {
  isolation: isolate;
  overflow-y: scroll;

  &__detector {
    z-index: 1;
    width: 100%;
    height: var(--detector-height);
    pointer-events: none;

    // position:absoluteを使わずにdetectorをslotのコンテンツの上に被せるため、
    // negative marginでDOMの持っている高さを外にずらした後にtranslateYでDOMの見た目だけ中に戻す
    &--top {
      margin-top: calc(-1 * var(--detector-height));
      transform: translateY(100%);
    }

    &--bottom {
      margin-bottom: calc(-1 * var(--detector-height));
      transform: translateY(-100%);
    }
  }
}
</style>
